import React from 'react'

const IncidentsIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.3984 8.59961L11.3984 0.59961C10.6016 -0.201172 9.39844 -0.201172 8.60156 0.59961L0.601563 8.59961C-0.199219 9.39649 -0.199219 10.5996 0.601563 11.3965L8.60156 19.3965C9.39844 20.1973 10.6016 20.1973 11.3984 19.3965L19.3984 11.3965C20.1992 10.5996 20.1992 9.39649 19.3984 8.59961ZM11 14.998H9V12.998H11V14.998ZM9 10.998H11V4.99805H9V10.998Z"
    fill="#EC5976"
  />
)

export default IncidentsIcon
